import React, { useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@qga/roo-ui/components';
import { getQueryPayWith, getQueryMinPrice, getQueryMaxPrice } from 'store/router/routerSelectors';
import { PAYMENT_METHODS } from 'lib/enums/payment';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';
import PriceFilter from 'components/Filters/Search/PriceFilter';
import PayWith from 'components/Filters/Search/PayWith';
import { PAYWITH_TOGGLE_ENABLED } from 'config';
import FilterItem from './FilterItem';

const PriceFilterItem = () => {
  const dispatch = useDispatch();
  const minPrice = useSelector(getQueryMinPrice);
  const maxPrice = useSelector(getQueryMaxPrice);
  const payWith = useSelector(getQueryPayWith);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ minPrice: undefined, maxPrice: undefined });
  }, [updateQuery]);

  return (
    <FilterItem
      buttonText="Price"
      isHighlighted={minPrice > 0 || maxPrice > 0 || payWith === PAYMENT_METHODS.POINTS}
      clearFilters={clearFilters}
    >
      <Fragment>
        {PAYWITH_TOGGLE_ENABLED && (
          <Box mb={4}>
            <PayWith onChange={updateQuery} hideClear />
          </Box>
        )}
        <PriceFilter onChange={updateQuery} />
      </Fragment>
    </FilterItem>
  );
};

export default PriceFilterItem;
